import { useLocation } from 'react-router-dom';
import { TextLink } from 'palette/TextLink';
import { BEAUTY_CATEGORY_NAME } from '@common/Filters/constants';
import { useTranslation } from '@common/Hooks/useTranslation';
import { BEMBlock } from '@helpers/classnames';
import './MwcDescription.scss';

export function MwcDescription() {
    const translate = useTranslation();

    const { pathname } = useLocation();

    const [block, BEMElement] = BEMBlock('mwc-description');

    const label = pathname.includes(BEAUTY_CATEGORY_NAME)
        ? translate('mwc_plp_filters_text_beauty')
        : translate('mwc_plp_filters_text');

    return (
        <div className={block}>
            {label}
            <TextLink
                isNewTab
                className={BEMElement('link')}
                href={translate('mwc_plp_filters_url')}
            >
                {translate('read_more_2')}
            </TextLink>
        </div>
    );
}
